import throttle from 'lodash.throttle';

const LOCAL_STORAGE_STATE_KEY = 'applicationState';

const loadState = (key) => {
  try {
    let serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    // NOTE: special handling for old model/models/etc. verbiage
    serializedState = serializedState.replaceAll('selectedTalModelIds', 'selectedModelIds');
    serializedState = serializedState.replaceAll('talModels', 'models');
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveStateToLocalStorage = throttle((key, state) => {
  try {
    const localState = loadState(LOCAL_STORAGE_STATE_KEY) || {};
    localState[key] = state[key];
    localStorage.setItem(LOCAL_STORAGE_STATE_KEY, JSON.stringify(localState));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}, 500);

export const hydrateStore = (initialState = {}) => {
  const hydratedState = loadState(LOCAL_STORAGE_STATE_KEY);
  return hydratedState || initialState;
};
